import angular from 'angular';
import analytics from 'common/analytics';

export default class ModalService {
    /* @ngInject */
    constructor($q, navigationService) {
        this.$q = $q;

        navigationService.onSuccess(() => {
            this.modals.forEach((modal) => modal.dismiss());
        });

        this.modals = [];
    }

    open(modal) {
        modal = modal || {};
        modal.bindings = modal.bindings || {};
        modal.bindings.index = this.modals.length;

        modal.promise = this.$q((resolve, reject) => {
            modal.close = this.safeCall(modal, resolve);
            modal.dismiss = this.safeCall(modal, reject);
            modal.bindings.onClose = this.addCallback(modal, modal.bindings.onClose, modal.close);
            modal.bindings.onDismiss = this.safeCall(modal, (...args) => {
                analytics.trackModalDismissByTrigger();
                return modal.dismiss(...args);
            });
        }).finally(() => {
            let index = this.modals.indexOf(modal);
            if (index >= 0) {
                this.modals.splice(index, 1);
            }
        });

        this.modals.push(modal);
        
        return modal.promise;
    }

    dismiss() {
        let modal = this.modals[this.modals.length - 1];
        if (modal && !modal.static) {
            modal.dismiss();
        }
    }

    // make sure the modal can't be closed/dismissed while it's being closed/dismissed
    safeCall(modal, callback) {
        return (...args) => {
            return modal.closing || callback(...args);
        };
    }

    addCallback(modal, pre, post) {
        pre = pre || angular.noop;

        return (...args) => {
            modal.closing = this.$q.when(pre(...args)).finally(() => delete modal.closing);
            return modal.closing.then(() => post(...args)).catch(() => null);
        };
    }
}



// WEBPACK FOOTER //
// ./src/application/service/modal.service.js